'use client';

import { useQuery } from '@tanstack/react-query';

import { Account } from '@air/api';

import { useIsLoggedIn } from './useIsLoggedIn';

export const ACCOUNT_KEY = 'ACCOUNT';

export const getAccountKey = () => {
  return [ACCOUNT_KEY];
};

export const useAccount = () => {
  const { isLoggedIn } = useIsLoggedIn();

  return useQuery({
    enabled: isLoggedIn,
    queryFn: Account.get,
    queryKey: getAccountKey(),
    staleTime: Infinity,
  });
};
